import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';
import { List } from 'lodash';

interface GeneralLabInfoState {
    MyBriefFinancial?:List<JSON>,
    MyBriefLabConfirmation?:List<JSON>,
    MyBriefLabStatistics?:List<JSON>,
    MyBriefInstrumentTemperature?:List<JSON>,
    MyBriefSystem?:List<JSON>,
    MyBriefStorage?:List<JSON>,
    MyBriefQC?:List<JSON>
}
  
const initialState:GeneralLabInfoState = {
    MyBriefFinancial:[],
    MyBriefLabConfirmation:[],
    MyBriefLabStatistics:[],
    MyBriefInstrumentTemperature:[],
    MyBriefSystem:[],
    MyBriefStorage:[],
    MyBriefQC:[],
    
}

export const GeneralLabInfoSlice = createSlice({
    name:"generalLabInfo",
    initialState,
    reducers:{
        UpdateGeneralLabInfo: (state,action) => {
            state.MyBriefFinancial = action.payload.MyBriefFinancial;
            state.MyBriefLabConfirmation = action.payload.MyBriefLabConfirmation;
            state.MyBriefLabStatistics = action.payload.MyBriefLabStatistics;
            state.MyBriefInstrumentTemperature = action.payload.MyBriefInstrumentTemperature;
            state.MyBriefSystem = action.payload.MyBriefSystem;
            state.MyBriefStorage = action.payload.MyBriefStorage;
            state.MyBriefQC = action.payload.MyBriefQC;
        },
        AddGeneralLabInfo: (state,action) => (
            initialState
        ),
        EditGeneralLabInfo: (state,action) => (
            initialState
),
        RemoveGeneralLabInfo: (state,action) => (
            initialState
        )
    }
})

export const {UpdateGeneralLabInfo,AddGeneralLabInfo,EditGeneralLabInfo,RemoveGeneralLabInfo} = GeneralLabInfoSlice.actions

export const selectLabBackupInfo = (state: RootState) => state.backupInfo

export default GeneralLabInfoSlice.reducer;